import React from "react";
import {
  Row,
  Badge,
  DropdownMenu,
  DropdownItem,
  Button,
  Table,
  Input,
  Card,
  CardBody,
  CardHeader,
  UncontrolledTooltip, DropdownToggle, UncontrolledDropdown,
  Col
} from "reactstrap";
import ReactTable from "react-table";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment'
import TinyURL from "tinyurl";
import Chip from '@material-ui/core/Chip';
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import Pagination from "../../assets/js/Pagination";
import { imageFileExtension, getImageFile, getRandomRolor,millisecondToHour } from "../../settings/shared/commonMethod"
import SchedulerService from "../../services/api/Scheduler";
import axios from 'axios'
import RunService from "../../services/api/Run";
import StorageService from '../../services/api/Storage';
import { toast } from 'react-toastify';
import { Scrollbars } from 'react-custom-scrollbars';
import { uuidv4 } from "components/Notebook/operations/notebook";
import HashLoader from "react-spinners/HashLoader";
import Dialog from 'react-dialog'
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import SchedulerNoPopup from "components/Scheduler/SchedulerNopopup";
import { INTERVALSEARCH } from "settings/shared/constants";


const styles = {
  chaticon: {
    cursor: 'pointer'
  },
  chatbutton: {
    borderColor: 'transparent',
    backgroundColor: 'transparent',
    boxShadow: 'transparent',
  },
  expandStyles: {
    backgroundColor: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1
  },
  expandStyles_Comman: {
    backgroundColor: "#000000",
    color: "#2dce89",
    fontSize: "0.2rem",
    letterSpacing: 1,
    width: 550,
    height: 'auto',
    marginTop: 5,
    marginLeft: 30,
    marginBottom: 2
  },
  expandStyles_param: {
    fontSize: "0.8rem",
    letterSpacing: 1,
    width: 550,
    marginTop: 5,
    marginLeft: 30
  },
  logbtn: {
    backgroundColor: "#5e72e4",
    color: "#ffffff",
    fontSize: "0.8rem",
    letterSpacing: 1,
    borderRadius: 8,
    height: 30,
    width: 50,
    padding: 0,
    marginLeft: 10
  },
  removedialog: {
    top: '50%',
    width: '250px'
  },

  error: {
    color: "rgb(255, 0, 0)",
    fontSize: 13,
    // padding: "6px 200px 6px 250px",
    borderRadius: 6
  },
}

class SchedulerRunDetails extends React.Component {
  constructor(props) {
    super(props);
    this.searchTimeOut = 0;
    this.onPageChange = this.onPageChange.bind(this);
    this.state = {
     chooseschedulerId : props.SchedulerId,
     products:[],
     input: "",
      messages: [],
      input_user: [],
      input_userEmail: [],
      open: false,
      columns: [],
      chatMsg: [],
      loading:false,
      localName: null,
      localPhoto: null,
      chatDbId: null,
      socketLoadFlag: false,
      logState: false,
      expanded: {},
      runname: "",
      filter: false,
      count: 0,
      logDetails: [],
      parasetm: [],
      UserList: [],
      filtered: [],
      updatePageNumber: 0,
      totalPages: 0,
      showuserListFlag: false,
      countitem: 0,
      countPagination: 0,
      rundatalength: '',
      runprojectname: '',
      copied: false,
      sharefile: false,
      sharetinyurl: '',
      gettinylink: '',
      copylink: '',
      isRunActionOpen: false,
      modalParameter: false,
      chatrundata: [],
      tags: [],
      randomcolor: '',
      DownloadUrl: '',
      myContent: '',
      fileType: '',
      parametersTablesdata: [],
      paraset: [],
      parasetTblState: [],
      parasetvalue: '',
      parameterSet: [],
      dropdownOpen: false,
      filterBy: "Runs",
      suggestions: [],
      value: "",
      tabId:"Runs",
      checked: [],
      selected:[],
      selectedRows:[],
      compareRow:[],
      schedulerDataById:[],
      schedulerDeatails:{},
      editFlag:true,
      listPageNumber:0
    };

  }


componentDidMount() {
  // this.getRunByScdulerId();
  var urlSearchParams = new URLSearchParams(window.location.search);
   var params = Object.fromEntries(urlSearchParams.entries());
   if(Object.keys(params).length !== 0){
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.setState({
      listPageNumber:params.page,
      chooseschedulerId:params.id,
    },()=>{
      // console.log(this.state.chooseschedulerId)
      this.getSchedulerById();
      this.getRunByScdulerId();
    })
   }
}

getSchedulerById = () =>{
    SchedulerService.getSchedulerbyId(this.state.chooseschedulerId)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        this.setState({
          schedulerDataById:response.schedulerDTOS[0],
          schedulerDeatails:response.schedulerDTOS[0].scheduleOn
        });
          } else {
            this.setState({}); 
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    }).catch((error) => {
      this.setState({}); 
    })
}


getRunByScdulerId = ()=> {
  // console.log(this.state.chooseschedulerId)
  this.setState({ loading: true});// To load table data in to product array

  let schData = {
    scheduleId:this.state.chooseschedulerId
  }
  let size = 10;
  RunService.getRunbySize(schData, this.state.updatePageNumber, size)
    .then((response) => {
      if (response.status === 'SUCCESS') {
        let runSDTO = response.runDetails.content;
        // console.log(runSDTO)
        this.renderData(runSDTO);
        this.setState({ loading: false,  totalPages: response.runDetails.totalPages });// To load table data in to product array
      } else {
        this.setState({ loading: false, totalPages: response.runDetails.totalPages });// To load table data in to product array    
        toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    })
}


onPageChange(pageIndex) {
  this.setState({
    updatePageNumber: pageIndex,
    // countPagination: this.state.countPagination + 1
  }, () => {
    this.getRunByScdulerId();
    // if (this.state.filtered.length != 0) {
    //   this.filterMethod(this.state.filtered)
    // } else {
    //   this.state.countPagination == 2 ? this.GetRunsData() : console.log("");
    // }
  });
}

closeViewScheduler = () =>{
  // this.props.history.push("schedule")
  this.props.history.push("/schedule?id="+this.state.chooseschedulerId+"&page="+this.state.listPageNumber);
}

onEditScheduler = (id) =>{
  this.setState({
    editFlag:!this.state.editFlag
  },()=>{
   //  this.toggleScheduler();
  })
}

OpenStorageView = (name, event) => {
  event.preventDefault()
  localStorage.setItem("filePathStorage", name);
  let currentUrl = window.location.href;
  let reg = window.location.pathname+window.location.search;
  let path = name.slice(-1) === "/" ? "/storage?path=" + name : "/storageView?file=" + name; // check folder or file
  let redirectUrl = currentUrl.replace(reg, path);
  window.open(redirectUrl, "_blank");
}

  // Download particular file in input or code
  downloadparticularFiles = (fileName, rid, type) => {
    StorageService.downloadObjectUrl(fileName)
      .then((response) => {
        const link = document.createElement('a');
        link.href = response.download_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }

  GetLink = (name, event, from) => {
    this.setState({ loading: true })
    event.preventDefault()
    localStorage.setItem("filePathStorage", name);
    let currentUrl = window.location.href;
    let reg = window.location.pathname + window.location.search;
    let redirectUrl = currentUrl.replace(reg, "/storageView?file=" + name);
    TinyURL.shorten(redirectUrl).then((res) => {
      this.setState({ copiedtxt: res })
      var tempInput = document.createElement("input");
      tempInput.value = this.state.copiedtxt;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);

      if (from === "modelinput") {
        this.setState({ copiedmodelinput: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modelcode") {
        this.setState({ copiedmodelcode: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modeloutputfile") {
        this.setState({ copiedmodeloutputfile: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      } else if (from === "modeloutputcodefile") {
        this.setState({ copiedmodeloutputcodefile: "Shareable link Copied" })
        setTimeout(() => {
          this.closeerror()
        }, 500);
      }
    })
  }

  closeerror = () => {
    this.setState({ loading: false, copiedmodelinput: "", copiedmodelcode: "", copiedmodeloutputfile: "", copiedmodeloutputcodefile: "" })
  }

  handleClose = () => {
    this.setState({ isDialogOpen: false, logState: false, isRemoveDialogOpen: false, modalParameter: false })
  }

    // Hide and Show Log for each run
    HideandShowLog(flag, fileName, log) {
      this.setState({ modalloading: true, myContent: '' });
      let filepath = "jobs/" + fileName + "/logs/console.log"
      StorageService.downloadObjectUrl(filepath)
        .then((response) => {
          this.renderText(response.download_url);
          this.setState({ modalloading: false, DownloadUrl: response.download_url });
        }).catch((error) => {
          this.setState({ modalloading: false });
        });;
      this.setState({
        logState: !flag,
        isDialogOpen: true,
        logDetails: log
      })
    }

    renderText = (url) => {
      axios.get(url)
        .then(response => {
          this.setState({
            fileType: "others",
            myContent: response.data.toString()
          })
        })
        .catch(error => {
          // console.log(error);
          return error;
        });
    }


FilterData = () => {
  this.setState({ count: this.state.count + 1 });
  if (this.state.count % 2 === 0) {
    this.setState({ filter: true });
  }
  else {
    this.setState({ filter: false });
  }
}

filterMethod = (filter) => {
  this.setState({ filtered: filter }, () => {
    if (this.state.filtered.length === 2) {
      this.state.filtered.splice(0, 1);
    }
  })
  if (filter.length !== 0) {
    if (filter[filter.length - 1].id === "Id" && filter[filter.length - 1].value.length > 1) {
      this.filterDataLoadDelay(filter, this.state.updatePageNumber)
    } else if (filter[filter.length - 1].id === "RunTime" && filter[filter.length - 1].value.length > 1) {
      this.filterDataLoadDelay(filter, this.state.updatePageNumber)
    } else if (filter[filter.length - 1].value.length > 2) {
      this.filterDataLoadDelay(filter, this.state.updatePageNumber)
    }
  } else {
    if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getRunByScdulerId();
      }, 1500);
  }
}

filterDataLoadDelay = (filter, pageNumber) => {
  if (this.timeout) clearTimeout(this.timeout);
  this.timeout = setTimeout(() => {
    //search function
    this.filterDataLoad(filter, pageNumber)

  }, 300);
}

async filterDataLoad(filter, pageNumber) {
  let size = 15;
  var runData = {};
  if(this.changeColumnName(filter[filter.length - 1].id) === "name" || this.changeColumnName(filter[filter.length - 1].id) === "jobId"){
    runData["jobIdOrNameStartsWith"] = filter[filter.length - 1].value
  }else{
    runData[this.changeColumnName(filter[filter.length - 1].id)] = filter[filter.length - 1].value
  }
  runData["projectIds"] = []
  if (this.searchTimeOut) clearTimeout(this.searchTimeOut);
    this.searchTimeOut = await new Promise(resolve => setTimeout(resolve, INTERVALSEARCH));
    const response = await RunService.getRunSearch(runData, pageNumber, size);
    if (response.status === 'SUCCESS') {
      let runSDTO = response.runDetails.content;
      this.renderData(runSDTO);
      this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
    } else {
      this.setState({ loading: false, socketLoadFlag: false, totalPages: response.runDetails.totalPages });// To load table data in to product array
      toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>);
    }
};

changeColumnName = (column) => {
  let ColumnName = ""
  if (column === "Name") { ColumnName = "name" }
  if (column === "RunTime") { ColumnName = "runTime" }
  if (column === "Cluster") { ColumnName = "clusterName" }
  if (column === "Id") { ColumnName = "jobId" }
  if (column === "Status") { ColumnName = "runStatus" }
  if (column === "StartTime") { ColumnName = "startTime" }
  if (column === "EndTime") { ColumnName = "endTime" }
  if (column === "createdBy") { ColumnName = "createdBy" }
  return ColumnName;
}

getColor = () => {
  let colorCode = getRandomRolor();
  return colorCode;
}

onCancelSchedulerConfirmation = () =>{
  confirmAlert({
    title: <h5>Cancel Scheduler</h5>,
    message: 'Are you sure to cancel scheduler?',
    buttons: [
      {
        label: 'Yes',
        onClick: () => this.cancelScheduler()
      },
      {
        label: 'No',
        onClick: () => console.log('no')
      }
    ]
  });
}

UpdateScheduleProject = (scheduleDo,type) => {
  // console.log(JSON.stringify(scheduleDo))
  // //event.preventDefault();
  this.setState({ loading: true });
    SchedulerService.updateScheduler(scheduleDo,this.state.chooseschedulerId)
    .then((response) => {
      // console.log(response)
      if (response.status === 'SUCCESS') {
        this.setState({
          loading: false,
          schedulerDataById:response.schedulerDTOS[0],
          schedulerDeatails:response.schedulerDTOS[0].scheduleOn
        });
          } else {
            this.setState({loading: false}); 
            toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
      }
    }).catch((error) => {
      this.setState({loading: false}); 
    })
};

cancelScheduler = () =>{
  this.setState({ loading: false });
  SchedulerService.cancelSchedulerById(this.state.chooseschedulerId)
  .then((response) => {
    if (response.status === 'SUCCESS') {
      this.setState({
        loading: false,
      });
          toast.success(<i className="fas fa-check-circle">&nbsp; <b className="toast-txt">Scheduler Cancelled Successfully!</b></i>); 
        } else {
          this.setState({loading: false}); 
          toast.error(<i className="fas fa-times-circle">&nbsp; <b className="toast-txt">{response.errorMessage}</b></i>); 
            }
  }).catch((error) => {
    this.setState({loading: false}); 
  })
}

//Display Run table
renderData(runData) {
  let datas = [];
  this.state.products = [];
  // console.log('runData', runData)
  runData.map((item, index) => {
    let parametersTables_array = []
    let parametersTables_files = item.parametersTables
    if (parametersTables_files !== null) {
      for (let index = 0; index < parametersTables_files.length; index++) {
        parametersTables_array.push(parametersTables_files[index])
      }
      this.setState({
        parametersTablesdata: parametersTables_array,
        parameterSet: item.parameterSet === null ? "":item.parameterSet
      });
    }
    else {
      this.setState({
        parametersTablesdata: []
      });
    }
    if (item.runStatus === "Cancelled") {
      this.setState({ disabled: 'disabled' });
    } else if (item.runStatus === "Completed") {
      this.setState({ disabled: 'disabled' });
    } else if (item.runStatus === "Failed") {
      this.setState({ disabled: 'disabled' });
    } else {
      this.setState({ disabled: 'false' });
    }
    this.state.runname = item.name;
    let PrefixCodeFiles = [];
    if (item.codeFilesPrefix === null) {
      PrefixCodeFiles = item.modelCodeFiles
    } else if (item.codeFilesPrefix.length > 0) {
      var pre = item.codeFilesPrefix;
      var arr = item.modelCodeFiles
      var newArr = (pre + arr.join(';' + pre)).split(';');
      PrefixCodeFiles = newArr;
    } else {
      PrefixCodeFiles = item.modelCodeFiles
    }
    // RunService.GetMessages(item.jobId)
    //     .then((response) => {
    //       console.log('GetMessages',response[0].chatDOS.length)
    //       this.state.countitem = response[0].chatDOS.length;
    //       item.totalMessages =  response[0].chatDOS.length;
    //     })
    datas.push({
      Name:
        // <span title={item.name} className="overflowStyle overflowStyleWithIcon" key={item.name}>{item.name}</span>,
        <span title={item.name} className="overflowStyle" key={item.name}>{item.name}</span>,
        fullName:item.name,
      Id: item.jobId, Description: item.description, 
      RunTime: <span className="overflowStyle">{millisecondToHour(item.runTimeInMilliseconds,item.runStatus)}</span>,
      Cluster: <span title={item.clusterName} className="overflowStyle">{item.clusterName}</span>,
      //  Input:<div> <a href="#"><u> {item.modelInputFiles.length==0?"":"Input"}</u></a> </div>,
      //  Output:<div> <a href="#"><u>{item.outputFiles.length==0?"":"Output"}</u></a> {item.outputFiles.length==0?"":<span id="Download"><i className="fas fa-cloud-download-alt"></i></span>} </div>,
      Status:
        <div key={item.runStatus}>
          {(item.runStatus === "Starting" || item.runStatus === "Progress") &&
            <Badge color="" className="badge-dot"><i className="bg-yellow blink" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Executing" &&
            <Badge color="" className="badge-dot"><i className="bg-success blink" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Cancelled" &&
            <Badge color="" className="badge-dot"><i className="bg-darkgray" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Completed" &&
            <Badge color="" className="badge-dot"><i className="bg-blue" />{item.runStatus}</Badge>
          }
          {item.runStatus === "Failed" &&
            <Badge color="" className="badge-dot"><i className="bg-red" />{item.runStatus}</Badge>
          }
          {/* {item.runStatus === "PENDING" &&
            <span><i className="fas fa-stopwatch" style={{color:"#4877da",fontSize:14}}></i>&nbsp;&nbsp;Pending</span>
          } */}


        </div>

      , Cost: item.cost,
      DbId: item.id,
      scheduleId:item.scheduleId,
      createdBy: <span title={item.createdBy} className="overflowStyle">{item.createdBy}</span>,
      InputFile: item.modelInputFiles || [],
      InputFolders: item.modelInputFolders || [],
      CodeFile: PrefixCodeFiles || [],
      CodeFolders: item.modelCodeFolders || [],
      modelOutputCodeFiles: item.modelOutputCodeFiles != null ? item.modelOutputCodeFiles : [],
      modelOutputCodeFolders: item.modelOutputCodeFolders != null ? item.modelOutputCodeFolders : [],  //new
      OutputFile: item.modelOutputFiles != null ? item.modelOutputFiles : [],
      modelOutputFolders: item.modelOutputFolders != null ? item.modelOutputFolders : [],   //new
      Tags: item.tags || [],
      LogFiles: item.logEntries,
      Parameter: this.state.parametersTablesdata,
      // Parameter:item.parametersTables.length > 0 ? parametersTables_array : [],
      // parameterSet:item.parameterSet,
      parameterSet: this.state.parameterSet,
      StartTime:  <div key={item.startTime}>{item.startTime != null ? moment.utc(item.startTime).local().format('MMM DD, YYYY') : ""} <br></br>{item.startTime != null ? moment.utc(item.startTime).local().format('hh:mm A') : ""}<br /></div>,
      EndTime: <div key={item.endTime}>{item.endTime != null ? moment.utc(item.endTime).local().format('MMM DD, YYYY') : ""}<br></br> {item.endTime != null ? moment.utc(item.endTime).local().format('hh:mm A') : ""}</div>,
      // Rerun:<div className="text-right" style={{cursor:'pointer'}}  onClick={e => {
      //   e.preventDefault()
      //   this.updateRerun(item.id, item.masterJobId)}}><i className="fas fa-sync-alt mr-3 text-blue" ></i>Rerun</div>,        
    })
  });
  var checkedCopy = [];
  var selectAll = this.state.selectAll;
  datas.forEach(function(e, index) {
    checkedCopy.push(selectAll);
  });

  this.setState({
    products: datas,
    checked: checkedCopy,
    selectAll: selectAll
  });

}

handleClick = (e) => {
  e.preventDefault();
    if(e.type === "contextmenu") {
      var arrt = e.currentTarget.getAttribute("data_attr_id");
      document.getElementById(arrt).click();
  }  
}

  render() {
    return (
        <>
          <PanelHeader
            content={
              <div className="header text-center">

              </div>
            }
          />
          <div className="content">
          <LoadingOverlay
        active={this.state.loading}
        spinner={<ScaleLoader
          height={35}
          width={5}
          radius={2}
          margin={2}
          color={"#123abc"}
          loading={this.state.loading}
        />}
      >
            <Card>
             <CardHeader className=" bg-transparent">
                <Row className="align-items-center" style={{fontSize:14}}>
               <Col xs="12" className="text-right">
                <span className="actionicon" id={'editScheduler'+0} onClick={e=>this.onEditScheduler()}> 
                <i className="far fa-edit mr-2" style={{color:'#007bff',fontSize:20}}/> &nbsp;</span> 
                      <UncontrolledTooltip placement="top" target={'editScheduler'+0} delay={0}>
                          Edit Scheduler
                      </UncontrolledTooltip>

                      <span className="actionicon" style={{marginRight:26}} id={'cancelScheduler'+1} onClick={e=>this.onCancelSchedulerConfirmation()}> 
                        <i className="far fa-calendar-times text-red mr-2" style={{color:'#007bff',fontSize:20}}/> &nbsp;</span> 
                        <UncontrolledTooltip placement="top" target={'cancelScheduler'+1} delay={0}>
                        Cancel Scheduler
                      </UncontrolledTooltip> 
                      {/* <div onClick={this.closeViewScheduler} style={{cursor:'pointer'}}> */}
                        {/* <span className="close clear-filter">×</span> */}
                      {/* </div> */}
                      <span className="actionicon" id={'close'+0} onClick={this.closeViewScheduler}> 
                      <i className="fas fa-times" style={{fontSize:20}}/> &nbsp;</span> 
                      <UncontrolledTooltip placement="top" target={'close'+0} delay={0}>
                          Close
                      </UncontrolledTooltip>

                   </Col>
                
                    {/* <div className="col text-right">
                     <div >
                      <span className="actionicon" id={'editScheduler'+0} onClick={e=>this.onEditScheduler()}> <i className="far fa-edit mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
                      <UncontrolledTooltip placement="top" target={'editScheduler'+0} delay={0}>
                          Edit Scheduler
                      </UncontrolledTooltip>

                      <span className="actionicon" id={'cancelScheduler'+1} onClick={e=>this.onCancelSchedulerConfirmation()}> 
                        <i className="far fa-calendar-times text-red mr-2" style={{color:'#007bff'}}/> &nbsp;</span> 
                        <UncontrolledTooltip placement="top" target={'cancelScheduler'+1} delay={0}>
                        Cancel Scheduler
                      </UncontrolledTooltip>   
                    </div>
                      <div onClick={this.closeViewScheduler} style={{cursor:'pointer'}}>
                        <span className="close clear-filter">×</span>
                      </div>
                    </div> */}
                   
                </Row>                  
              </CardHeader>
              <CardBody>
              <div className="carcontent">
            <Row>
            <Col>
            <Card>
            <CardBody>
            <SchedulerNoPopup
                            SchedulerMode="Update"
                            EditFlag={this.state.editFlag}
                            schedulerDataById={this.state.schedulerDataById}
                            // SchedulerId={this.state.selectedSchedulerId}
                            SchedulerUpdate={this.UpdateScheduleProject}
                            ScheduleType={"Run"}
                          />
            </CardBody>
            </Card>
            </Col>
            </Row>
            <Row>
            
            <Col xs="12">
            <ReactTable
                      PaginationComponent={Pagination}
                      getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                          return {
                            onClick: e => {
                              // {this.state.selected[rowInfo.row.Id] === true ? this.callRow(rowInfo,'false') : this.callRow(rowInfo,'true')}
                          },
                            style: {
                              background: this.state.selected[rowInfo.row.Id] === true ? 'rgb(223 227 233)' : 'white',
                              color:this.state.selected[rowInfo.row.Id] === true ? 'black' : 'black'
                            }
                          }
                        }else{
                          return {
                        
                          }
                        }
                      }}
                      onFilteredChange={filtered => this.filterMethod(filtered)}
                      filtered={this.state.filtered}
                      data={this.state.products}
                      manual
                      expanded={this.state.expanded}
                      onExpandedChange={(expanded, index, event) => {
                        this.setState({ expanded });
                      }}
                      columns={
                        [
                          {
                            Header: "",
                            columns: [
                              {
                                expander: true,
                                Header: () => <strong className="filterdata" onClick={e => this.FilterData()}>&nbsp; &nbsp; &nbsp;<i className="fas fa-filter"></i> </strong>,
                                width: 60,
                                Expander: ({ isExpanded, ...rest }) =>
                                  <div>

                                    {isExpanded
                                      ? <span style={{verticalAlign:"text-bottom"}}>-</span>
                                      : <span style={{verticalAlign:"text-bottom"}}>+</span>}
                                  </div>,
                                style: {
                                  cursor: "pointer",
                                  fontSize: 20,
                                  padding: "0",
                                  textAlign: "center",
                                  userSelect: "none"
                                },
                              }
                            ]
                          },
                          // {
                          //   id: "scheduler",
                          //   accessor: "",
                          //   Cell: ({ original}) => {
                          //     return (   
                          //     original.scheduleId !== null && <i className="far fa-clock" title="Scheduled Run" style={{verticalAlign:"top",color:"#4776d9"}}/>
                          //     );
                          //   },
                          //   sortable: false,
                          //   width: 20,
                          
                          // },
                          {
                            Header: 'Name',
                            accessor: 'Name',
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'Tags',
                            accessor: 'Tags',
                            show: false
                          },
                          {
                            Header: 'fullName',
                            accessor: 'fullName',
                            show: false
                        
                          },

                          {
                            Header: 'scheduleId',
                            accessor: 'scheduleId',
                            show: false
                          },
                          {
                            Header: 'DbId',
                            accessor: 'DbId',
                            show: false
                          },
                          {
                            Header: 'Id',
                            accessor: 'Id',
                            filterable: this.state.filter,
                            // sortable: true,
                            // filterable: false
                          }
                          , {
                            Header: 'Description',
                            accessor: 'Description',
                            show: false
                          }, {
                            Header: 'RunTime',
                            accessor: 'RunTime',
                            maxWidth: 120,
                            filterable: this.state.filter,

                          }, {
                            Header: 'Cluster',
                            accessor: 'Cluster',
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'Status',
                            accessor: 'Status',
                            filterable: this.state.filter,
                          }, {
                            Header: 'StartTime',
                            accessor: 'StartTime',
                            filterable: this.state.filter,
                          }, {
                            Header: 'EndTime',
                            accessor: 'EndTime',
                            filterable: this.state.filter,
                          },
                          {
                            Header: 'Cost',
                            accessor: 'Cost',
                            sortable: true,
                            filterable: this.state.filter,
                          }, 
                          {
                            Header: 'createdBy',
                            accessor: 'createdBy',
                            sortable: true,
                            filterable: this.state.filter,
                          },{
                            Header: '',
                            accessor: 'ds',
                            filterable: this.state.filter,
                          },
                          // {
                          //   Header: 'Re-Run',
                          //   accessor: 'Rerun',
                          //   maxWidth: 70
                          // },
                          {
                            Header: 'InputFile',
                            accessor: 'InputFile',
                            show: false
                          },
                          {
                            Header: 'InputFolders',
                            accessor: 'InputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFile',
                            accessor: 'CodeFile',
                            show: false
                          },
                          {
                            Header: 'modelOutputCodeFolders',
                            accessor: 'modelOutputCodeFolders',
                            show: false
                          },
                          {
                            Header: 'modelOutputFolders',
                            accessor: 'modelOutputFolders',
                            show: false
                          },
                          {
                            Header: 'CodeFolders',
                            accessor: 'CodeFolders',
                            show: false
                          },
                          {
                            Header: 'OutputFile',
                            accessor: 'OutputFile',
                            show: false
                          }, {
                            Header: 'modelOutputCodeFiles',
                            accessor: 'modelOutputCodeFiles',
                            show: false
                          },
                          {
                            Header: 'Parameter',
                            accessor: 'Parameter',
                            show: false
                          },
                          {
                            Header: 'parameterSet',
                            accessor: 'parameterSet',
                            show: false
                          },
                          {
                            Header: 'LogFiles',
                            accessor: 'LogFiles',
                            show: false
                          },
                          {
                            Header: 'masterJobId',
                            accessor: 'masterJobId',
                            show: false
                          },
                        ]

                      }
                      defaultSorted={[
                        {
                          id: "StartTime",
                          desc: true
                        }
                      ]}
                      defaultPageSize={10}
                      pages={this.state.totalPages}
                      onPageChange={this.onPageChange}
                      SubComponent={(v) => <div>
                        <br />
                        <Row>
                          <Col lg="1"><span><b>Name :</b></span></Col>
                          <Col lg="3"><span >{v.row.fullName}
                          </span></Col>
                          <Col lg="4"><span><b>Description :</b>&nbsp; &nbsp; &nbsp; {v.row.Description}</span></Col>
                          {/* <Col lg="4">{v.row.scheduleId !== null &&<span style={{marginLeft:10}} onClick={e=>this.onClickSchedulerId(v.row.scheduleId)}><a className="text-primary" style={styles.chaticon} ><u><i className="far fa-clock pr-1" style={{ color: "#4776d9"}}></i>Scheduler Details</u> </a></span>}</Col> */}

                        </Row>
                        <br />
                        <Row>
                          <Col lg="1" style={{ marginTop: 10 }}><span><b>Tags :</b></span></Col>
                          <Col lg="10">
                            <Scrollbars autoHeight autoHeightMin={50} autoHeightMax={150}>
                              {v.row.Tags.map((item, index) => (
                                <Chip
                                  label={item}
                                  size="small"
                                  // onDelete={(chip) => this.removeChip(v.row.DbId, index)}
                                  style={{ background: this.getColor(), color: "#fff", fontWeight: 600, marginTop: 5, marginLeft: 3 }}
                                />))}
                              {/* <ChipInput
                                value={v.row.Tags}
                                placeholder="Add a Tag"
                                onAdd={value => this.addChip(v.row.DbId, value, v.row.Tags)}
                              /> */}
                            </Scrollbars><br />
                            {/* <TagsInput value={v.row.Tags} onChange={evt => this.handleChangeTags(v.row.DbId, evt)}/> <br/> */}
                            {/* <Button className="tag-update-btn" onClick={e => this.CrateTags(v.row.DbId,v.row.Tags)}>Update</Button> */}
                          </Col>
                          <Col lg="1"></Col>
                        </Row>
                        <br />
                        <div>{(v.row.InputFile.length !== 0 || v.row.InputFolders.length > 0) &&
                          <span ><br /> <b>Model Input Files : &nbsp;<span style={styles.error}>{this.state.copiedmodelinput}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.InputFile.length + v.row.InputFolders.length) > 7 ? "scorllit" : ""}>
                                  <ul>
                                    {v.row.InputFolders.map((item, index) => (
                                      <li style={{ marginTop: 10 }} className="listyle" key={uuidv4()} >
                                        <span
                                          className="file"
                                          data-type="folder"
                                          // onClick={onFileClick}
                                          onClick={e => this.OpenStorageView(item, e)}
                                        >
                                          <a href="# " className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  {v.row.InputFile.map((item, index) => (
                                    <ul>
                                      <li className="listyle" key={uuidv4()} >
                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                        <span className="file" data-type="file" data_attr_id={"codeId"+index+"n"}
                                          onContextMenu={this.handleClick}>
                                          <span className="text-primary"><i
                                              className={getImageFile(imageFileExtension(item))}></i></span>
                                          <a href="# " className="text-primary" style={styles.chaticon}><u>{item}</u>
                                          </a>
                                        </span>
                                          <DropdownToggle tag="span" id={"codeId"+index+"n"}>
                                          </DropdownToggle>
                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem
                                              onClick={e => this.OpenStorageView(item, e)}
                                            >
                                              <span >
                                                <i className="fas fa-binoculars mr-2"></i> View
          </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                            >
                                              <span >
                                                <i className="fas fa-download mr-2" /> Download
          </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.GetLink(item, e, 'modelinput')}
                                            >
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>
                                            </DropdownItem>

                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </td>
                              </tr>
                              </tbody>
                            </Table>
                          </span>
                        }
                        </div>
                        <br />
                        <div>{(v.row.CodeFile.length > 0 || v.row.CodeFolders.length > 0) &&
                          <span ><b>Model Code Files : &nbsp;<span style={styles.error}>{this.state.copiedmodelcode}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.CodeFile.length + v.row.CodeFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.CodeFolders.map((item, index) => (
                                      <li style={{ marginTop: 10 }} className="listyle">
                                        <span
                                          className="file"
                                          data-type="folder"
                                          // onClick={onFileClick}
                                          onClick={e => this.OpenStorageView(item, e)}
                                        >
                                          <a href="# " className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  {v.row.CodeFile.map((item, index) => (
                                    <ul>
                                      <li className="listyle">
                                        <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                        <span
                                              className="file"
                                              data-type="file"
                                              data_attr_id={"codeId"+index+"o"}
                                              onContextMenu={this.handleClick}
                                            >
                                              <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                              <a href="# " className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                            </span>
                                          <DropdownToggle tag="span" id={"codeId"+index+"o"}>  
                                          </DropdownToggle>
                                          <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                            <DropdownItem
                                              onClick={e => this.OpenStorageView(item, e)}
                                            >
                                              <span >
                                                <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                            >
                                              <span >
                                                <i className="fas fa-download mr-2" /> Download
                </span>
                                            </DropdownItem>
                                            <DropdownItem
                                              onClick={e => { this.GetLink(item, e, 'modelcode') }}
                                            >
                                              <div>
                                                <i className=" fas fa-link mr-2" />
                                                <span>Get Sharable Link</span>
                                              </div>

                                              {/* {this.state.copied ? <span style={{color: 'red'}}>Copied.</span> : null} */}



                                            </DropdownItem>

                                          </DropdownMenu>
                                        </UncontrolledDropdown>
                                      </li>
                                    </ul>
                                  ))}
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <div>{v.row.OutputFile.length !== 0 &&
                          <span ><b>Model Output Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputfile}</span></b>
                            <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.OutputFile.length + v.row.modelOutputFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.modelOutputFolders.map((item, index) => (
                                      <li style={{ marginTop: 10 }} className="listyle">
                                        <span
                                          className="file"
                                          data-type="folder"
                                          // onClick={onFileClick}
                                          onClick={e => this.OpenStorageView(item, e)}
                                        >
                                          <a href="# " className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  {v.row.OutputFile.length < 7 && <div>
                                    {v.row.OutputFile.map((item, index) => (
                                      <ul>
                                        <li className="listyle">
                                          <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                          <span
                                                className="file"
                                                data-type="file"
                                                data_attr_id={"codeId"+index+"p"}
                                                onContextMenu={this.handleClick}
                                              >
                                                <span className="text-primary"><i className={getImageFile(imageFileExtension(item))}></i></span>
                                                <a href="# " className="text-primary" style={styles.chaticon} ><u>{item}</u> </a>
                                              </span>
                                            <DropdownToggle tag="span" id={'codeId'+index+"p"}>
                                            </DropdownToggle>
                                            <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                              <DropdownItem
                                                onClick={e => this.OpenStorageView(item, e)}
                                              >
                                                <span >
                                                  <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                              >
                                                <span >
                                                  <i className="fas fa-download mr-2" /> Download
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.GetLink(item, e, 'modeloutputfile')}
                                              >
                                                <div>
                                                  <i className=" fas fa-link mr-2" />
                                                  <span>Get Sharable Link</span>
                                                </div>
                                              </DropdownItem>

                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </li>
                                      </ul>
                                    ))}
                                  </div>}
                                  {/*{v.row.OutputFile.length > 7  && <div className="scrollit">
                            {v.row.OutputFile.map((item,index) => (
                              <ul>
                                <li><span>
                                <UncontrolledDropdown direction={ (index > 4 ? "up" : "right")}>
                                    <DropdownToggle tag="span" onClick={e => e.preventDefault()} style={{ color: '#007bff ' }}>
                                      <span
                                        className="file"
                                        data-type="file"
                                      // onClick={onFileClick}
                                      >
                                        <a className="text-primary" style={styles.chaticon} ><u>{item.filePath}</u> </a>
                                      </span>
                                    </DropdownToggle>
                                    <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                      <DropdownItem
                                        onClick={e => this.OpenStorageView(item.filePath, e)}
                                      >
                                        <span >
                                          <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.downloadparticularFiles(item.filePath, item.runId, item.inputType)}
                                      >
                                        <span >
                                          <i className="fas fa-download mr-2" /> Download
                </span>
                                      </DropdownItem>
                                      <DropdownItem
                                        onClick={e => this.GetLink(item.filePath, e)}
                                      >
                                        <div>
                                          <i className=" fas fa-link mr-2" />
                                          <span>Get Sharable Link</span>
                                        </div>
                                      </DropdownItem>

                                    </DropdownMenu>
                                  </UncontrolledDropdown>
                                </span></li>
                              </ul>
                            ))}
                             </div>}*/}
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <div>{v.row.modelOutputCodeFiles.length !== 0 &&
                          <span ><b>Model Output Code Files :  &nbsp;<span style={styles.error}>{this.state.copiedmodeloutputcodefile}</span></b> <br />
                            <Table id={uuidv4()}>
                              <tbody style={{border:'none'}}>
                              <tr><td>
                                <div className={(v.row.modelOutputCodeFiles.length + v.row.modelOutputCodeFolders.length) > 7 ? "scrollit" : ""}>
                                  <ul>
                                    {v.row.modelOutputCodeFolders.map((item, index) => (
                                      <li style={{ marginTop: 10 }} className="listyle">
                                        <span
                                          className="file"
                                          data-type="folder"
                                          // onClick={onFileClick}
                                          onClick={e => this.OpenStorageView(item, e)}
                                        >
                                          <a href="# " className="text-primary" style={styles.chaticon} ><u><i className="fas fa-folder pr-1"></i>{item}</u> </a>
                                        </span>
                                      </li>
                                    ))}
                                  </ul>
                                  <div>
                                    {v.row.modelOutputCodeFiles.map((item, index) => (
                                      <ul>
                                        <li className="listyle">
                                          <UncontrolledDropdown direction={(index > 4 ? "up" : "right")}>
                                          <span className="file" data-type="file" data_attr_id={"codeId"+index+"q"}
                                            onContextMenu={this.handleClick}>
                                            <span className="text-primary"><i
                                                className={getImageFile(imageFileExtension(item))}></i></span>
                                            <a href="# " className="text-primary" style={styles.chaticon}><u>{item}</u>
                                            </a>
                                          </span>
                                            <DropdownToggle tag="span" id={"codeId"+index+"q"}>
                                            </DropdownToggle>
                                            <DropdownMenu persist className="dropdown-menu-arrow storagedropdown">
                                              <DropdownItem
                                                onClick={e => this.OpenStorageView(item, e)}
                                              >
                                                <span >
                                                  <i className="fas fa-binoculars mr-2"></i> View
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.downloadparticularFiles(item, item.runId, item.inputType)}
                                              >
                                                <span >
                                                  <i className="fas fa-download mr-2" /> Download
                </span>
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={e => this.GetLink(item, e, 'modeloutputcodefile')}
                                              >
                                                <div>
                                                  <i className=" fas fa-link mr-2" />
                                                  <span>Get Sharable Link</span>
                                                </div>
                                              </DropdownItem>

                                            </DropdownMenu>
                                          </UncontrolledDropdown>
                                        </li>
                                      </ul>
                                    ))}
                                  </div>
                                </div>
                              </td>
                              </tr>
                            </tbody>
                            </Table>
                          </span>
                        }
                        </div>

                        <Row>
                          <Col lg="2">
                            {v.row.Parameter.length > 0 && <span><b>Business Levers : </b></span>}</Col>
                          <Col lg="4">
                            {v.row.Parameter.length > 0 && <span>
                              {
                                <Scrollbars autoHeight>
                                  {v.row.Parameter.length > 0 &&
                                    <Table responsive className="table-hover paratbl"
                                      id="tab_logic"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Variables </th>
                                          <th style={{ width: "80%" }}> Values </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {v.row.Parameter.map((item, index) => (
                                          item.row !== false &&
                                          <tr id="addr0" key={index}>
                                            <td className="variabletxt">{item.key}</td>
                                            <td style={{ width: "80%" }}>
                                              <Input
                                                className="form-control-alternative normaldisabled valuetxt"
                                                defaultValue={item.value}
                                                style={{ border: 'none', borderRadius: '5px' }}
                                                id={uuidv4()} 
                                                name="parameterSet"
                                                disabled
                                                type="text"
                                              />
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </Table>
                                  }
                                  {v.row.Parameter.length === 0 && <span style={{ color: 'darkgray', fontSize: '14px' }}>  &nbsp; No Business Levers Found</span>}


                                </Scrollbars>
                              }
                            </span>
                            }</Col>
                          {/* <Col lg="2">
                            {v.row.Parameter.length > 0 &&
                              <img src={openpara} onClick={e => this.toggleModalParameter(v.row.Parameter, v.row.parameterSet)} style={{ cursor: 'pointer', width: '30px', height: '30px' }} />
                            }
                          </Col> */}
                        </Row>
                        <br />
                        
                        <div>
                          <span ><b>Log :</b>{
                            this.state.logState === false ?
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState, v.row.Id, v.row.LogFiles)}>Show</Button> :
                              <Button style={styles.logbtn} onClick={e => this.HideandShowLog(this.state.logState, v.row.Id, v.row.LogFiles)}>Hide</Button>
                          }
                          </span>

                        </div>
                      </div>
                      }
                      // showPaginationTop
                      showPaginationBottom={true}
                      className="-striped -highlight primary-pagination tableHeight"
                    />
                </Col>
                {/* <Col style={{borderLeft:"1px solid #d3d3d3"}} xs="3">
                  <Row>

                  </Row>
                </Col> */}
                </Row>
              </div>
              </CardBody>
              </Card>
              </LoadingOverlay>

              </div>
              <div>{this.state.logState && <Dialog
              title="Logs"
              modal={true}
              onClose={this.handleClose}
            // value={this.state.dialogid}
            >
              <LoadingOverlay
                active={this.state.modalloading}
                spinner={<HashLoader
                  size={50}
                  color={"#fff"}
                  loading={this.state.modalloading}
                />}
              >
                <Scrollbars style={styles.expandStyles_Comman} autoHeight autoHeightMin={400}
                  thumbMinSize={30} >
                  {(this.state.fileType === "others") &&

                    // <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                    //   {this.state.myContent}
                    // </p>
                    <p style={{ marginLeft: 5, fontSize: "0.70rem", marginBottom: 10, lineHeight: 2 }}>
                      {this.state.myContent.split("\n").map((i, key) => {
                        return <div>{i}</div>;
                      })}
                    </p>
                  }
                </Scrollbars>
              </LoadingOverlay>
            </Dialog>}
            </div>
      </>
    );
  }
}

export default SchedulerRunDetails;
